import type { State } from '../../types';

export const getBaseUrl = (state: State): string => state.app.baseUrl;
export const getBoardId = (state: State): number => state.app.boardId;
export const getProjectKey = (state: State): string => state.app.projectKey || '';
export const isFirstDataLoaded = (state: State): boolean => state.app.isFirstDataLoaded;
